import React from 'react'
import {
    DefaultButton,
    DirectionalHint,
    TextField, TooltipDelay, TooltipHost,
} from '@fluentui/react'
import 'react-phone-input-2/lib/style.css'

/**
 * @typedef {object} SideButtonProps
 * @property {string=} buttonMessage buttonMessage
 * @property {Function=} buttonOnClick buttonOnClick
 * @property {string?=} [buttonIconName] buttonIconName
 */

/**
 * Text Field With Tooltip
 * @param {SideButtonProps & import('@fluentui/react').ITextFieldProps} props props
 * @returns {JSX.Element} Element
 */
export default function TextFieldWithSideButton({
    buttonMessage,
    buttonOnClick,
    buttonIconName = 'Add',
    ...props
}) {
    const {
        disabled,
        value,
        label,
        onChange,
        borderless,
        readOnly,
        errorMessage,
        placeholder,
        type,
        multiline,
        resizable,
        autoAdjustHeight,
        required,
        min,
    } = props

    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
            }}
        >

            <TextField
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                label={label}
                placeholder={placeholder}
                value={value}
                readOnly={readOnly}
                borderless={borderless}
                onChange={onChange}
                type={type}
                required={required}
                multiline={multiline}
                autoAdjustHeight={autoAdjustHeight}
                errorMessage={errorMessage}
                resizable={resizable}
                disabled={disabled}
                min={min}
                styles={{ root: { width: '100%' } }}
            />
            <div
                style={{
                    marginLeft: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    height: '100%',
                }}
            >
                <TooltipHost
                    content={buttonMessage}
                    directionalHint={DirectionalHint.topCenter}
                    delay={TooltipDelay.zero}
                >
                    <DefaultButton
                        iconProps={{ iconName: buttonIconName }}
                        style={{
                            width: '2rem', // Largeur fixe pour un carré
                            height: '2rem', // Hauteur fixe pour un carré
                            minWidth: '2rem', // Empêche le redimensionnement
                            padding: 0, // Supprime les marges internes
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        onClick={ev => {
                            ev.preventDefault()
                            buttonOnClick()
                        }}
                    />
                </TooltipHost>
            </div>
        </div>

    )
}
